import { useMutation } from '@tanstack/react-query'
import { updateDraftDistribution } from '../../services/Draft'

export const useUpdateDraftDistribution = () => {
  return useMutation({
    mutationFn: ({ draftId, inputData }) =>
      updateDraftDistribution(draftId, inputData),
    onSuccess: () => {
      const channel = new BroadcastChannel('drafts_channel')
      channel.postMessage({ type: 'DRAFT_UPDATED' })
      channel.close()
    }
  })
}
